/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from "react";
// import { userRegister } from '../../actions';
import { Button, Col, Form, Input, Row } from "antd";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { getUrlToken } from "../../utils/url-hash-params";
import { useDispatch } from "react-redux";
import { changePassword } from "../../actions/user";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const ChangePasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const token = getUrlToken(location?.search);
  const dispatch: any = useDispatch();
  const [passwordError, setPasswordError] = useState(null);
  const [visible, setVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const onFinish = (values: any) => {
    const payload = {
      password: values?.password,
      token: token,
    };
    setPasswordError(null);
    // Submit the form or perform other actions
    dispatch(
      changePassword(payload, (resp: any) => {
        if (resp) {
          navigate("/");
        }
      })
    );
  };

  return (
    <div className="authforms" style={{ padding: "152px 60px" }}>
      <div className="authHeadings">
        <button
          onClick={() => {
            navigate(-1);
          }}
          className="btn textAuthHeading"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <rect
              x="0.4"
              y="0.4"
              width="23.2"
              height="23.2"
              rx="11.6"
              stroke="#0d6efd"
              strokeWidth="0.8"
            />
            <path
              d="M14 8L10 12L14 16"
              stroke="#0d6efd"
              strokeWidth="1.25"
              strokeLinecap="round"
            />
          </svg>{" "}
        </button>

        <div className="text-white text-[20px] mb-[10px] font-medium">
          Change <span>Password</span>
        </div>
      </div>
      <Row>
        <Col lg={24} md={24} sm={24}>
          <Form
            className="formControl"
            {...layout}
            form={form}
            name="email_password_form"
            onFinish={onFinish}
            layout="vertical"
            // onFinishFailed={onFinishFailed}
            initialValues={{ remember: true }}
            style={{ maxWidth: "600px", margin: "auto" }}
          >
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please enter your password!" },
                { min: 8, message: "Password must be at least 8 characters!" },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                  message:
                    "Password must include uppercase, lowercase, number, and special character!",
                },
              ]}
            >
              <div className="relative">
                <Input
                  type={visible ? "text" : "password"}
                  placeholder="Password"
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[0px] p-[15px] 2xl:p-[20px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] text-white"
                />
                <span
                  className="hide-show-col absolute 2xl:top-[22px] top-[18px] right-5 text-[#48bb89] text-sm cursor-pointer"
                  onClick={() => setVisible(!visible)}
                >
                  {visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
                </span>
              </div>
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "Please confirm your password!",
                },
                {
                  validator(_, value) {
                    if (!value || form.getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                },
              ]}
            >
              <div className="relative">
                <Input
                  type={confirmVisible ? "text" : "password"}
                  placeholder="Confirm Password"
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[0px] p-[15px] 2xl:p-[20px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#005A90] text-white"
                />
                <span
                  className="hide-show-col absolute 2xl:top-[22px] top-[18px] right-5 text-[#48bb89] text-sm cursor-pointer"
                  onClick={() => setConfirmVisible(!confirmVisible)}
                >
                  {confirmVisible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
                </span>
              </div>
            </Form.Item>
            {passwordError && (
              <div style={{ color: "red" }}>{passwordError}</div>
            )}

            <Form.Item>
              <Button
                className="btn btn-primary w-100"
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ChangePasswordForm;
